import styled, { css } from 'styled-components';
import {
  Text as TextLayoutComponent,
  Button as ButtonLayoutComponent,
} from '@playbookux/playbook-web-core';

import { Modal as SemanticModal, Input as SemanticInput } from 'semantic-ui-react';

export const ContainerEdit = styled.div`
  padding: 20px;
`;

export const EditText = styled(TextLayoutComponent)`
  cursor: pointer;
  color: ${({ theme }) => theme.color.primary};
`;

export const Modal = styled(SemanticModal)`
  padding: 30px;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const ModalButton = styled(ButtonLayoutComponent)`
  min-width: 100px;

  &.ui.button {
    margin-left: auto;
  }
`;

export const ModalCancelButton = styled(ButtonLayoutComponent.Inverted)`
  min-width: 100px;
`;

export const Input = styled(SemanticInput)`
  padding-bottom: 30px;
  width: 90%;
`;

export const Label = styled.label`
  padding-right: 10px;
`;

export const ModalText = styled.p`
  margin-bottom: 20px;
  font-size: 16px;
  ${({ theme }) => css`
    color: ${theme.color.text};
  `}
`;

export const ModalHeader = styled(TextLayoutComponent.Bold)`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
`;

export const TextError = styled(TextLayoutComponent.Error)`
  text-align: center;
  margin-bottom: 15px;
`;
